var _excluded = ["label", "options", "required", "className", "error"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
import { Label } from 'reactstrap';
var SelectField = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var label = _ref.label,
    options = _ref.options,
    required = _ref.required,
    className = _ref.className,
    error = _ref.error,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Label, {
    htmlFor: label
  }, label, " ", required && /*#__PURE__*/React.createElement("span", {
    className: "required"
  }, "*")), /*#__PURE__*/React.createElement("select", Object.assign({
    className: "form-select ".concat(className, " ").concat(error ? 'error' : ''),
    ref: ref
  }, otherProps), options.map(function (option) {
    return /*#__PURE__*/React.createElement("option", {
      key: option.value,
      value: option.value
    }, option.label);
  })));
});
SelectField.defaultProps = {
  required: false,
  error: false
};
export default SelectField;